const regexp = /%/g;


export function parseValue(value: string): string | null {
    const cleaned = value.replace(regexp, '');
    try {
        return JSON.parse(cleaned);
    } catch {
        return cleaned;
    }
}
